




















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: {}
})
export default class Confirm extends Vue {
  @Prop({ default: '' }) readonly label!: string
  @Prop([Boolean]) value: boolean | undefined

  @Emit('input')
  updateValue() {
  }
}
